import React, { useState } from 'react'
import { Button, Form, Image } from 'semantic-ui-react'
import gql from 'graphql-tag'
import { useMutation } from '@apollo/client'
import { useForm } from '../util/hooks'
import { FETCH_POSTS_QUERY } from '../util/graphql'
import firebase from "../firebase"

export default function PostForm() {

    // const [newFile, SetNewFile] = useState("");
    const [ready, SetReady] = useState(true);
    const [progress, SetProgress] = useState(0);
    const [image, SetImage] = useState("");


    const fileChange = (event) => {
        console.log(ready, "status on upload start")
        uploadToFirebase(event.target.files[0])
    };


    const { values, onChange, onSubmit } = useForm(createPostCallback, {
        body: "",
    });

    const [createPost, { error }] = useMutation(CREATE_POST_MUTATION, {
        variables: values,
        update(proxy, result) {
            const data = proxy.readQuery({
                query: FETCH_POSTS_QUERY
            })
            // console.log(result)
            const new_post = result.data.createPost;
            proxy.writeQuery({
                query: FETCH_POSTS_QUERY,
                data: { getPosts: [new_post, ...data.getPosts] }
            });
            values.body = "";
            SetImage("");


        },
        onError(err) {
            console.log("ERROR: ", err)
        },
    })


    function uploadToFirebase(file) {

        SetReady(false);
        let bucketname = 'images'
        let storageRef = firebase.storage().ref(`${bucketname}/${file.name}`)
        let uploadTask = storageRef.put(file)
        uploadTask.on(firebase.storage.TaskEvent.STATE_CHANGED, (snapshot) => {
            var uploadProgress = 0;
            uploadProgress = (snapshot.bytesTransferred / snapshot.totalBytes) * 100;
            console.log(uploadProgress)
            var x = Number((uploadProgress).toFixed(1));
            SetProgress(x)
        }, (error) => {
            console.log(error)
        },
            () => {
                uploadTask.snapshot.ref.getDownloadURL().then(function (downloadURL) {
                    // console.log(downloadURL)
                    SetImage(downloadURL);
                    // localStorage.setItem("img", downloadURL)
                    values.image = downloadURL;
                    SetReady(true);

                    // console.log("READY STATUS \n", ready)
                    // console.log("Image Link \n", image)
                });
            })
    }



    function createPostCallback() {
        createPost(image);
    }





    return (
        <>
            <Form onSubmit={onSubmit}>
                <h2 className="centerMe">Post Something:</h2>
                {ready ? <h5>&nbsp;</h5> : <h1 className="centerMe"><div className="lds-ripple"><div></div><div></div></div> <h4>progress : % {progress}</h4></h1>}
                <Form.Field>
                    {ready && image ? <Image src={image} className="image"></Image> : <h5>&nbsp;</h5>}
                    <Form.Input
                        placeholder="Hi World"
                        name="body"
                        onChange={onChange}
                        value={values.body}
                        error={error ? true : false}
                    />
                    <Button as="label" htmlFor="file" type="button" disabled={!ready}>
                        {!ready ? "please wait while uploading image to server" : "choose an image"}
                    </Button>
                    <input type="file" id="file" accept="image/x-png,image/gif,image/jpeg" hidden onChange={fileChange} />
                    <Button type="submit" color={!ready ? "grey" : "teal"} disabled={!ready}>Post</Button>
                </Form.Field>
            </Form>

            {
                error && (
                    <div className="ui error message" style={{ marginBottom: 20 }}>
                        <ul className="list">
                            <li>{error.graphQLErrors[0].message}</li>
                        </ul>
                    </div>
                )
            }
        </>
    )
}

const CREATE_POST_MUTATION = gql`
mutation createPost($body:String!, $image:String!){
    createPost(body:$body, image:$image){
        id body createdAt username image
        likes{
            id username createdAt
        }
        likeCount
        comments{
            id body username createdAt
        }
        commentCount
    }
}
`
